var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("app-mail-template-edit", {
            attrs: { value: _vm.config.Template },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }